import { Book, Author } from '@fable/types'
import { BookSchema } from 'seo/types'

const getReviewValue = ({
  value,
  defaultValue,
}: {
  value: number | null
  defaultValue: number | null
}) => {
  if (!!value && value > 0) return value
  return defaultValue
}

export const bookSchema = (book: Book): BookSchema => {
  const schema: BookSchema = {
    '@context': 'https://schema.org',
    '@type': 'Book',
    name: book.title,
    image: book.cover_image,
    bookFormat: 'EBook',
    numberOfPages: book.page_count,
    inLanguage: 'English',
    isbn: book.isbn,
    author: bookAuthorSchema(book.authors),
    url: book.url,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: getReviewValue({
        value: book.review_average,
        defaultValue: 5,
      }),
      reviewCount: getReviewValue({
        value: book.review_count,
        defaultValue: 1,
      }),
    },
  }

  return schema
}

export const bookAuthorSchema = (authors: Author[]) => {
  if (!authors) return []
  return authors.map((author) => ({
    '@type': 'Person',
    name: author.name,
    url: `https://fable.co/author/${author.slug}`,
  }))
}
